<template>
  <div class="professional-google-integration">
    <div class="loading loading-lg" v-if="loading" />
    <template v-else>
      <div class="empty mt-2" v-if="!status.connected">
        <div class="empty-icon">
          <fa-icon :icon="['fab', 'google']" size="3x" />
        </div>
        <p class="empty-title h5">Google não conectado</p>
        <p class="empty-subtitle">
          Este profissional ainda não conectou a conta Google. A conexão só pode
          ser feita pelo próprio profissional, em "Meu perfil" — nenhum
          administrador consegue autorizar isso por ele.
        </p>
      </div>
      <template v-else>
        <p class="text-small text-gray">
          <fa-icon :icon="['fal', 'check-circle']" class="text-success" />
          Conectado como {{ status.email }}
        </p>
        <div class="divider" />
        <label class="form-switch">
          <input
            type="checkbox"
            v-model="calendarSync.enabled"
            @change="onToggle"
          >
          <i class="form-icon" /> Sincronizar a agenda de atendimentos deste
          profissional com o Google Calendar
        </label>
        <template v-if="calendarSync.enabled">
          <div class="loading mt-2" v-if="loadingCalendars" />
          <select
            v-else
            class="form-select mt-2"
            v-model="calendarSync.calendarId"
            @change="onSelectCalendar"
          >
            <option value="" disabled>Selecione uma agenda</option>
            <option v-for="cal in calendars" :key="cal.id" :value="cal.id">
              {{ cal.summary }}{{ cal.primary ? ' (principal)' : '' }}
            </option>
          </select>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    professionalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      loadingCalendars: false,
      saving: false,
      status: {
        connected: false,
        email: null,
      },
      calendarSync: {
        enabled: false,
        calendarId: '',
        calendarName: '',
      },
      calendars: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      return this.$httpX.get(`/professionals/${this.professionalId}/google`)
        .then(({ data }) => {
          this.status = { connected: data.connected, email: data.email };
          this.calendarSync = {
            enabled: data.calendarSync?.enabled || false,
            calendarId: data.calendarSync?.calendarId || '',
            calendarName: data.calendarSync?.calendarName || '',
          };
          if (this.calendarSync.enabled) {
            this.loadCalendars();
          }
        })
        .catch(this.$toast.error)
        .finally(() => {
          this.loading = false;
        });
    },
    loadCalendars() {
      this.loadingCalendars = true;
      return this.$httpX.get(`/professionals/${this.professionalId}/google/calendars`)
        .then(({ data }) => {
          this.calendars = data;
        })
        .catch(this.$toast.error)
        .finally(() => {
          this.loadingCalendars = false;
        });
    },
    onToggle() {
      if (this.calendarSync.enabled) {
        this.loadCalendars();
        if (this.calendarSync.calendarId) {
          this.save();
        }
      } else {
        this.save();
      }
    },
    onSelectCalendar() {
      const selected = this.calendars
        .find(cal => cal.id === this.calendarSync.calendarId);
      this.calendarSync.calendarName = selected ? selected.summary : null;
      this.save();
    },
    save() {
      this.saving = true;
      return this.$httpX.put(`/professionals/${this.professionalId}/google/calendar-sync`, {
        enabled: this.calendarSync.enabled,
        calendarId: this.calendarSync.calendarId,
        calendarName: this.calendarSync.calendarName,
      })
        .then(() => {
          this.$toast.success('Preferência de sincronização salva!');
        })
        .catch(this.$toast.error)
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
